<script setup>
import { computed } from 'vue';
import { formatDate } from 'shared/helpers/DateHelper';
import { CsBadge } from 'dashboard/components/ui/commslayer';
import { useI18n } from 'widget/composables/useI18n';

const props = defineProps({
  date: {
    type: String,
    required: true,
  },
});

const { t } = useI18n();

const formattedDate = computed(() =>
  formatDate({
    date: props.date,
    todayText: t('TODAY'),
    yesterdayText: t('YESTERDAY'),
  })
);
</script>

<template>
  <div
    data-component="ChatDateSeparator"
    data-version="2"
    class="flex items-center justify-center h-[50px]"
  >
    <CsBadge>
      {{ formattedDate }}
    </CsBadge>
  </div>
</template>
